<template>
    <fci-dialog :title="this.$f.tc('advanceSearch')" :width="1000" v-model="show">
        <v-layout>
            <v-flex xs4 style="padding: 10px">
                <v-checkbox
                    dense
                    class="ma-0 pa-0"
                    :label="this.$f.tc('useVietnameseAccent')"
                    v-model="useAccent"
                    @change="search"
                ></v-checkbox>
                <div class="mb-3 for-only">{{ $f.tc('bothStepAndCard') }}</div>
                <v-text-field
                    :label="this.$f.tc('name')"
                    outlined
                    dense
                    v-model="name"
                    clearable
                ></v-text-field>
                <v-autocomplete
                    :label="this.$f.tc('card')"
                    v-model="cardType"
                    :items="cardTypeList"
                    clearable
                    outlined
                    dense
                    hide-details
                ></v-autocomplete>
                <div class="mb-3 mt-5 for-only">{{ $f.tc('forStepOnly') }}</div>
                <v-autocomplete
                    :label="this.$f.tc('intent')"
                    v-model="intent"
                    :items="intentList"
                    item-text="label"
                    item-value="label"
                    clearable
                    outlined
                    dense
                    hide-details
                ></v-autocomplete>
                <div class="mb-3 mt-5 for-only">{{ $f.tc('forCardOnly') }}</div>
                <v-textarea
                    :label="this.$f.tc('text')"
                    v-model="cardText"
                    outlined
                    dense
                    clearable
                ></v-textarea>
                <v-text-field
                    :label="this.$f.tc('buttonNamePayload')"
                    v-model="buttonText"
                    outlined
                    dense
                    clearable
                ></v-text-field>
                <v-autocomplete
                    :label="this.$f.tc('variable')"
                    v-model="variable"
                    :items="variableList"
                    item-text="name"
                    item-value="name"
                    clearable
                    outlined
                    dense
                ></v-autocomplete>
            </v-flex>
            <v-flex xs4>
                <div class="group">{{ $f.tc('step') }} | {{ stepList.length }} {{ $t('results') }}</div>
                <div class="fci-list fci-scrollbar step-container">
                    <div v-for="step in stepList" :key="step.code" class="fci-list-item" @click="selectStep(step)">
                        {{ step.name }}
                    </div>
                </div>
            </v-flex>
            <v-flex xs4>
                <div class="group">{{ $f.tc('card') }} | {{ cardList.length }} {{ $t('results') }}</div>
                <div class="fci-list fci-scrollbar step-container">
                    <div v-for="card in cardList" :key="card.code" class="fci-list-item" :class="{active: card.code === activeCardCode}" @click="selectCard(card)">
                        <v-icon class="mr-1">{{ MapCardTypeToData[card.card_type_id].icon }}</v-icon>
                        {{ card.name }}
                        <v-icon v-if="!card.activate" class="ml-2" >mdi-lightbulb-off</v-icon>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </fci-dialog>
</template>

<script>
import lodash from 'lodash'
import { ButtonType, CardType, MapCardTypeToData } from '@/utils/const'
import { mapState } from 'vuex'
import FciDialog from '@/components/FciDialog'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'

export default {
    name: 'SearchText',
    components: { FciDialog },
    mixins: [DialogMixin],
    data () {
        return {
            MapCardTypeToData,
            stepList: [],
            cardList: [],
            name: '',
            cardText: '',
            cardType: '',
            buttonText: '',
            intent: '',
            variable: '',
            useAccent: false
        }
    },
    computed: {
        ...mapState({
            allStepList: state => state.scenario.stepList,
            allCardList: state => state.scenario.cardList,
            intentList: state => {
                return lodash.orderBy(state.scenario.intentList, 'label')
            },
            variableList: state => state.scenario.variableList,
            activeCardCode: state => state.scenario.activeCardCode
        }),
        cardTypeList () {
            let cardTypeList = []
            for (let i in MapCardTypeToData) {
                cardTypeList.push({
                    text: this.$f.tc(MapCardTypeToData[i].name),
                    value: i
                })
            }
            return cardTypeList
        }
    },
    methods: {
        search () {
            // filter step
            this.stepList = this.allStepList
            let name = this.getSearchValue(this.name)
            if (name) {
                this.stepList = this.stepList.filter(step => this.getSearchValue(step.name).includes(name))
            }
            if (this.cardType) {
                this.stepList = this.stepList.filter(step => {
                    for (let card of step.cards) {
                        if (card.card_type_id === this.cardType) {
                            return true
                        }
                    }
                    return false
                })
            }
            if (this.intent) {
                this.stepList = this.stepList.filter(step => {
                    for (let config of step.config) {
                        if (config.config === this.intent) {
                            return true
                        }
                    }
                    return false
                })
            }
            // filter card
            let cardText = this.getSearchValue(this.cardText)
            let buttonText = this.getSearchValue(this.buttonText)
            this.cardList = this.allCardList
            if (name) {
                this.cardList = this.cardList.filter(card => this.getSearchValue(card.name).includes(name))
            }
            if (this.cardType) {
                this.cardList = this.cardList.filter(card => card.card_type_id === this.cardType)
            }
            if (cardText) {
                this.cardList = this.cardList.filter(card => {
                    if (!card.config.text) {
                        return false
                    }
                    return this.getSearchValue(card.config.text).includes(cardText)
                })
            }
            if (buttonText) {
                this.cardList = this.cardList.filter(card => {
                    let buttonList = []
                    if (card.config.buttons) {
                        buttonList = card.config.buttons
                    } else if (card.config.carousel_cards) {
                        for (let carousel of card.config.carousel_cards) {
                            buttonList.push(...carousel.buttons)
                        }
                    }
                    for (let button of buttonList) {
                        if (this.getSearchValue(button.title).includes(buttonText)) {
                            return true
                        }
                        if (button[ButtonType.GO_TO_STEP]) {
                            let stepName = button[ButtonType.GO_TO_STEP].split('#')[0]
                            if (this.getSearchValue(stepName).includes(buttonText)) {
                                return true
                            }
                        } else if (button[ButtonType.URL]) {
                            if (button[ButtonType.URL].includes(buttonText)) {
                                return true
                            }
                        } else if (button[ButtonType.CALL_PHONE]) {
                            if (button[ButtonType.CALL_PHONE].includes(buttonText)) {
                                return true
                            }
                        } else if (button[ButtonType.WEBVIEW]) {
                            let webview = this.$store.state.scenario.webViewList.find(
                                webview => webview.code === button[ButtonType.WEBVIEW]
                            )
                            if (this.getSearchValue(webview.name).includes(buttonText)) {
                                return true
                            }
                        }
                    }
                    return false
                })
            }
            if (this.variable) {
                this.cardList = this.cardList.filter(card => {
                    let conditionList = card.config.conditions
                    if (!conditionList) {
                        return false
                    }
                    for (let condition of conditionList) {
                        if (condition.name === this.variable) {
                            return true
                        }
                    }
                    if (card.card_type_id === CardType.CONFIG) {
                        if (card.config.clear_memory.variables.includes(this.variable)) {
                            return true
                        }
                        for (let item of card.config.set_memory) {
                            if (item.name === this.variable) {
                                return true
                            }
                        }
                    }
                    return false
                })
            }
        },
        selectStep (step) {
            this.close()
            this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                activeStepCode: step.code
            })
        },
        selectCard (card) {
            this.close()
            this.$store.dispatch(this.$at.scenario.ACTIVE_DATA, {
                activeCardCode: card.code
            })
        },
        getSearchValue (text) {
            if (!text) {
                return ''
            }
            return this.useAccent ? text.trim().toLowerCase() : this.$ut.noAccent(text)
        }
    },
    watch: {
        name: 'search',
        cardText: 'search',
        buttonText: 'search',
        intent: 'search',
        cardType: 'search',
        variable: 'search'
    }
}
</script>

<style scoped lang="scss">
.step-container {
    height: 700px;
    overflow: auto;
    flex: 1 1 1px;
}

.fci-list-item {
    border-bottom: none;
}
.fci-list-item-active {
    background: #f6f6f6;
}
.group {
    font-weight: bold;
    padding: 5px;
    border-bottom: 2px solid #F2F4FA;
}

.for-only {
    font-weight: bold;
    font-size: 1.2em;
}
</style>
